import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Item} from "../../../../../framework/model/core/items/item";
import {CartModel} from "../../../../../framework/model/core/items/cartModel";
import {ItemProvider} from "../../providers/item-provider/item-provider.service";
import {OrderService} from "../../../../services/OrderService";
import {Events} from "../../../../../framework/providers/events";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {AppSettings} from "../../../../conf/appSettings";

@Component({
    selector: 'app-item-box',
    templateUrl: './item-box.component.html',
    styleUrls: ['./item-box.component.scss'],
})
export class ItemBoxComponent implements OnInit {

    @Input()
    public model: Item;

    @Input()
    public view: string = 'big';

    @Input()
    public options: object = {};
    @Input()
    public listOptions: object = {};

    @Input()
    public cartModel: CartModel;

    public cartOptions: object;

    @Input()
    public inCart: boolean = false;

    @Input()
    public listPrefix: string;

    @Input()
    public listIndex: number;

    public subPrefix: string;
    public isAgent: boolean;
    public settings: string;

    @ViewChild('itemcontent') itemContent: ElementRef;

    constructor(public itemProvider: ItemProvider, public orderService:OrderService, public appevents:Events, public tools:ModelToolsProvider, public appsettings:AppSettings) {
    }

    ngOnInit() {
        if (!this.cartModel)
            this.cartModel = this.model.cart_model;

        this.isAgent = this.orderService.isAgent();

        this.options['in_cart'] = this.inCart
        this.subPrefix = this.tools.getRandomize();
        this.settings = this.appsettings.getSettings('items');

        this.setCartOptions();

        this.setTicketsSubscribes()
    }

    setTicketsSubscribes(){
        if(this.inCart) return;

        this.appevents.subscribe('activeTicketChanged', (res)=>{
            let cartModel = this.itemProvider.getTicketCartModel(this.model);
            this.setCartOptions();
            this.cartModel = cartModel;
        }, this.subPrefix);


        this.appevents.subscribe('activeTicketChanged_'+this.model.data.id, (params)=>{
            let cartModel = this.itemProvider.getTicketCartModel(this.model, false, params['ticketId']);
            this.cartModel = cartModel;
        }, this.subPrefix);
    }

    ngOnDestroy()
    {
        this.appevents.unsubscribe('activeTicketChanged', this.subPrefix);
        this.appevents.unsubscribe('activeTicketChanged_'+this.model.data.id, this.subPrefix);
    }

    setCartOptions() {
        // console.log(this.model)
        let options = {}
        options['out_of_stock'] = this.model.data.outofstock;
        options['is_top_item'] = this.model.data.isTopItem;
        options['view_type'] = this.model.data.view_type;
        options['cart_options'] = !options['out_of_stock'] && !options['is_top_item'] && parseFloat(this.cartModel.getValue('corePrice')) > 0;

        let buttons = null;

        switch (options['view_type']){
            default:{
                buttons = [
                    {
                        'value': 1,
                        'icon': 'add',
                        'text': null,
                        'add_to_value': true,
                        'outside_item_page': this.listOptions ? this.listOptions['outside_item_page'] : true
                    },
                    {
                        'value': 1,
                        'icon': null,
                        'cartKey': 'amount',
                        'extra_key': this.model.data.packageUnits > 1 ? 'package_amount' : null,
                        'extra_key_text': 'packages',
                        'add_to_value': true,
                        'outside_item_page': this.listOptions ? this.listOptions['outside_item_page'] : true
                    },
                    {
                        'value': -1,
                        'icon': 'remove',
                        'text': null,
                        'add_to_value': true,
                        'outside_item_page': this.listOptions ? this.listOptions['outside_item_page'] : true
                    }
                ];

                break;
            }

            case 'business_card':{
                buttons = [
                    {
                        'value':null,
                        'icon': this.model.data.main_button_icon,
                        'text': this.model.data.main_button_title,
                    },
                ]
                break;
            }
        }

        // console.log(buttons, options)
        let global_options = this.orderService.getCartOptions();
        options['tickets'] = global_options['tickets'];

        if(!this.cartOptions) this.cartOptions = {}
        if(JSON.stringify(this.cartOptions['buttons'])!=JSON.stringify(buttons))
            this.cartOptions['buttons'] = buttons
        if(JSON.stringify(this.cartOptions['options'])!=JSON.stringify(options)) {
            this.cartOptions['options'] = options
        }
    }

    cartAction(option) {
        if(option['value'] === null){
            this.openItem();
            return
        }

        option['in_cart'] = this.inCart
        let cart_model = this.inCart ? this.cartModel : null

        if(!this.inCart && option['init-field']) {
            this.cartModel.data['init-field'] = option['init-field'];
        }

        cart_model = this.itemProvider.add_to_cart(this.model, option['value'], 'amount', option, cart_model);
        if(cart_model) this.cartModel = cart_model;

    }

    openItem() {
        let autoProps = this.model.data.autoProps || (this.inCart && this.model.data.propsLen);
        this.itemProvider.openItem(this.model, this.cartModel, autoProps, {'listIndex':this.listIndex, 'listPrefix':this.listPrefix});
        // this.cartModel.data['visible'] = true;
    }

    goTo(page, params = {}) {
        this.tools.goTo(page, params);
    }

    moveToTicket()
    {
        this.itemProvider.moveToTicket(this.model, this.cartModel);
    }

    setAgentToolVisible()
    {
        this.cartModel.data['visible'] = true;
        this.itemProvider.setAgentToolEditField(this.cartModel, this.model, 'amount', this.options);

    }
}
